module.exports = __webpack_public_path__ + "static/leaping-rabbit-945ff91d8fb5c3256713b96f73ac2f05.png";